module.exports = __webpack_public_path__ + "static/img/home_plataformas.892965a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_plataformas.png
// module id = 86
// module chunks = 0